import Marionette from 'backbone.marionette';
import memberCommitteesCompositviewTmpl from '../templates/member_committees_compositview.tpl';
import memberCommitteesItemview from './member_committees_itemview';
export default Marionette.CompositeView.extend({
  template: memberCommitteesCompositviewTmpl,
  childView: memberCommitteesItemview,
  tagName: 'table',
  className: "table table-hover table-sm",
  childViewContainer: "tbody",
  id: "committee-list"

  /*
  onShow: function() {
    $("#committee-list").dataTable({
      bSort: true,
      order: [[0, 'asc']],
      paging: false,
      //pagingType: 'simple',
      responsive: false,
      //lengthChange: false,
      bFilter: false,
     // "autoWidth": true,
    });
  }
  */
});